// extracted by mini-css-extract-plugin
export default {"companyContainer":"zK-z","companyImage":"AK-z","container":"BK-z","heading":"CK-z","darkText":"DK-z","smallHeading":"EK-z","darkBackground":"FK-z","whiteBackground":"GK-z"};